// extracted by css-extract-rspack-plugin
export default {"breadcrams":"MxTs_SgfsAdziBJd"};